<template>
  <div
    :style="{ fontSize: fontSize }"
    :class="[
      {
        'subscriber-avatar__sm': small,
        'subscriber-avatar__xs': xSmall,
        '--with-profile': withProfile
      },
      'subscriber-avatar'
    ]"
    @click="openProfile"
  >
    <div v-if="isLoading" class="subscriber-avatar__loading">
      <v-loader />
    </div>

    <div
      v-if="imageUrl"
      class="subscriber-avatar__image"
      :style="{
        backgroundImage: `url(${imageUrl})`
      }"
    ></div>
    <span
      v-else
      :title="text"
      class="subscriber-avatar__initials rounded-circle"
    >
      {{ initials }}
    </span>

    <member-profile-modal
      v-if="withProfile && subscriber && subscriber.user_id && isProfileOpen"
      :user-id="subscriber.user_id"
      @open="() => (isProfileOpen = true)"
      @close="() => (isProfileOpen = false)"
    />
  </div>
</template>

<script>
import { addToHash } from "@/lib/url-helpers"
import { getInitials } from "@/lib/utils"
import { THREAD_MODAL_HASH } from "@/lib/messages-utils"

export default {
  components: {
    MemberProfileModal: () => import("@/components/modals/MemberProfileModal")
  },

  props: {
    subscriber: { type: Object, default: null }, // TODO: rename this to user. Since, we're using this as user instead of subscriber
    small: { type: Boolean, default: false },
    xSmall: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    fontSize: { type: String, default: null },
    defaultText: { type: String, default: "" },
    withProfile: { type: Boolean, default: false }
  },

  data() {
    return {
      isProfileOpen: false
    }
  },

  computed: {
    imageUrl() {
      if (this.subscriber) {
        const avatarUrls =
          this.subscriber.avatarUrls || this.subscriber.avatar_urls

        if (avatarUrls) {
          if (this.small) {
            return avatarUrls.sm
          } else if (this.xSmall) {
            return avatarUrls.xs
          } else {
            // integrate imageSize prop to change to a different size
            return avatarUrls.sm
          }
        } else {
          return null
        }
      } else {
        return null
      }
    },

    text() {
      return this.subscriber
        ? this.subscriber.name ||
            this.subscriber.username ||
            this.subscriber.email ||
            this.subscriber.initials
        : this.defaultText
    },

    initials() {
      return this.subscriber?.initials
        ? this.subscriber.initials
        : getInitials(this.text)
    }
  },

  mounted() {
    this.$emit("init", this.openProfile.bind(this))
  },

  methods: {
    openProfile(e) {
      if (!this.withProfile) return
      if (!this.subscriber.user_id) return
      e?.stopPropagation()

      this.isProfileOpen = true

      this.$router.push(addToHash(this.$route.hash, THREAD_MODAL_HASH.PROFILE))
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.subscriber-avatar {
  align-items: center;
  background-color: $color-ui--grey-20;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  color: $color-ui--grey-70;

  &.--with-profile {
    cursor: pointer;
  }

  .subscriber-avatar__loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color-rgb--white, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .v-loader {
    height: $size--6;
    width: $size--6;
  }
}

.subscriber-avatar__image {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.subscriber-avatar__sm {
  height: 45px;
  width: 45px;
  min-height: 45px;
  min-width: 45px;
}

.subscriber-avatar__xs {
  height: $size--8;
  width: $size--8;
  min-height: $size--8;
  min-width: $size--8;

  font-size: 13px;
}
</style>
